import React from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import AnalyticsPdfPageRow from './AnalyticsPdfPageRow'
import AnalyticsPdfQuestionIcon from './AnalyticsPdfQuestionIcon'
import styles from './AnalyticsPdfPageDetails.module.css'

const ANALYTICS_PDF_PAGE_HEADERS = [
  { label: 'Page', hasTooltip: false },
  { label: 'Views', hasTooltip: false },
  { label: 'Unique', hasTooltip: false },
  { label: 'Avg. Time', hasTooltip: false },
  { label: 'Bounce Rate', hasTooltip: false },
  {
    label: 'Engagement',
    hasTooltip: true,
    tooltip: 'A percentage indicator of how many viewers made it to a page'
  }
]

const AnalyticsPdfPageDetailsTable = ({ pdfAnalytics }) => (
  <Card>
    <Card.Body>
      <h5 className="mb-3">Page-by-Page Analytics</h5>
      <p className="d-lg-none text-muted small mb-3">
        Engagement shows the percentage of viewers who made it to each page
      </p>
      <div className={styles.pageDetailsTable}>
        <Row className="fw-bold d-none d-lg-flex pb-3 border-bottom g-0">
          {ANALYTICS_PDF_PAGE_HEADERS.map((header) => (
            <Col key={header.label} lg={2}>
              <span className="d-inline-flex align-items-center gap-2">
                <span>{header.label}</span>
                {header.hasTooltip && <AnalyticsPdfQuestionIcon tooltip={header.tooltip} />}
              </span>
            </Col>
          ))}
        </Row>

        {pdfAnalytics.length > 0 ? (
          pdfAnalytics.map((page) => <AnalyticsPdfPageRow key={page.page} page={page} />)
        ) : (
          <p className="text-muted text-center mt-4">No page data available</p>
        )}
      </div>
    </Card.Body>
  </Card>
)

export default AnalyticsPdfPageDetailsTable
